export default {
      id: "arrow-icon-usage",
      viewBox: "0 0 12 7",
      url: __webpack_public_path__ + "sprite.svg#arrow-icon",
      toString: function () {
        return this.url;
      }
    }